(() => {
  const initialize = root => root.querySelectorAll('[data-care-slider]').forEach(slider => {
    if (slider.dataset.ready) return;
    slider.dataset.ready = 'true';
    const slides = [...slider.querySelectorAll('[data-care-slide]')];
    const dots = [...slider.querySelectorAll('[data-care-dot]')];
    const pause = slider.querySelector('[data-care-pause]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, timer, paused = motion.matches, hovered = false, focused = false, touchStart = null;
    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      if (!paused && !hovered && !focused && !document.hidden && !motion.matches) timer = setInterval(() => show(index + 1), 6500);
    };
    const show = requested => {
      index = (requested + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    };
    const move = amount => { show(index + amount); start(); };
    slider.querySelector('[data-care-prev]').addEventListener('click', () => move(-1));
    slider.querySelector('[data-care-next]').addEventListener('click', () => move(1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    const updatePause = () => { pause.textContent = paused ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label', paused ? pause.dataset.play : pause.dataset.pause); };
    pause.addEventListener('click', () => { paused = !paused; updatePause(); start(); });
    slider.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stop(); } });
    slider.addEventListener('pointerleave', () => { hovered = false; start(); });
    slider.addEventListener('focusin', () => { focused = true; stop(); });
    slider.addEventListener('focusout', event => { if (!slider.contains(event.relatedTarget)) { focused = false; start(); } });
    slider.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); } });
    slider.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].clientX; stop(); }, { passive: true });
    slider.addEventListener('touchend', event => { const delta = event.changedTouches[0].clientX - touchStart; if (touchStart !== null && Math.abs(delta) > 50) move(delta < 0 ? 1 : -1); touchStart = null; start(); }, { passive: true });
    const visibility = () => start();
    document.addEventListener('visibilitychange', visibility);
    const changeMotion = () => { paused = motion.matches; updatePause(); start(); };
    motion.addEventListener('change', changeMotion);
    slider.closest('.shopify-section')?.addEventListener('dw-care:dispose', () => { stop(); document.removeEventListener('visibilitychange', visibility); motion.removeEventListener('change', changeMotion); });
    updatePause(); show(0); start();
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.dispatchEvent(new Event('dw-care:dispose')));
})();
